import { Input, InputProps, Text } from '@mantine/core'
import { useTranslation } from 'next-i18next'
import { ChangeEvent, FC, useEffect, useId, useRef } from 'react'
import InputMask from 'react-input-mask'

type TMaskedInputComponentProps = {
  value: string
  onChange: (value: string) => void
  size: InputProps['size']
}

const MaskedInputComponent: FC<TMaskedInputComponentProps> = ({
  value,
  onChange,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.setSelectionRange(value.length, value.length)
    }
  }, [value])

  const parseInput = (input: string) => {
    const inputValue = input.toUpperCase().replace(/[^A-Z0-9-]/g, '')
    return inputValue
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = parseInput(event.target.value)
    onChange(inputValue)
  }

  const formatValue = (val: string): string => {
    const parts = val.match(/.{1,16}/g) || []
    return parts.join('-')
  }

  return (
    <InputMask
      mask="******-******-********"
      value={formatValue(value)}
      onChange={handleChange}
      maskChar={null}
      placeholder="______-______-________"
      {...props}
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      {inputProps => <Input {...inputProps} ref={inputRef} />}
    </InputMask>
  )
}

type TRedeemInput = {
  onChange?: (input: string) => void
  value?: string
}
const RedeemInput: FC<TRedeemInput> = ({ onChange, value }) => {
  const { t: tCommon } = useTranslation('common')
  const id = useId()

  return (
    <Input.Wrapper id={id} label={tCommon('product-key')}>
      <MaskedInputComponent
        size={'md'}
        onChange={data => {
          onChange?.(data)
        }}
        value={value || ''}
      />
      <div className="my-2">
        <Text c="dimmed">{tCommon('redeem-code-description')}</Text>
      </div>
    </Input.Wrapper>
  )
}

export default RedeemInput
